<div class="row">
  <div class="col-12">
    <div class="card">
      <div
        class="card-header spear-table-header-background d-flex justify-content-between"
      >
        <h6></h6>
      </div>
      <div class="card-body">
        <div class="col-12 primary-tab">
          <ul class="nav nav-tabs">
            <li class="nav-item" *ngFor="let tab of pageTabs">
              <button
                class="nav-link text-uppercase"
                [ngClass]="{
                  'active search-spear-background': activeTab == tab
                }"
                (click)="activeTab = tab"
              >
                {{ tab }}
              </button>
            </li>
          </ul>
          <ng-container *ngIf="activeTab == 'Overview'">
            <div class="row">
              <div class="col-9">
                <div class="search-spear-background" *blockUI="'program-location-details'">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-end w-100 my-2">
                        <div>
                          <button
                            class="btn viewBtn btn-primary text-white btn-sm mr-1"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                      <div
                        class="accordian-tab card-header title-space spear-table-header-background"
                      >
                        <h6 class="m-0">General Information</h6>
                        <div>
                          <button class="btn">
                            <em
                              (click)="generalInfo = !generalInfo"
                              class="fa fa-sort-desc"
                              [ngClass]="generalInfo ? '' : 'antirotate'"
                            ></em>
                          </button>
                        </div>
                      </div>
                      <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                        <div class="card border-0 card-scrollbar bg-transparent">
                          <div
                            class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                          >
                            <div class="row">
                              <div class="col-2 text-right">Street Address:</div>
                              <div class="col-6">
                                {{ programLocationData?.full_physical_address }}
                              </div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">City:</div>
                              <div class="col-6">{{programLocationData?.physical_city}}</div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">State:</div>
                              <div class="col-3">{{ programLocationData?.physical_state }}</div>
                            </div>
                            <div class="row my-2">
                              <div class="col-2 text-right">Zip:</div>
                              <div class="col-3">{{ programLocationData?.physical_zip }}</div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">Primary Program Contact:</div>
                              <div class="col-3">--</div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">Primary Phone:</div>
                              <div class="col-3">{{ programLocationData?.primary_phone  }}</div>
                            </div>
                            <div class="row my-2">
                              <div class="col-2 text-right">Billing Email:</div>
                              <div class="col-3">{{ programLocationData?.billing_email }}</div>
                            </div>
                            <div class="row">
                              <div class="col-2 text-right">Client Manager:</div>
                              <div class="col-3">--</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div
                        class="accordian-tab card-header title-space spear-table-header-background"
                      >
                        <h6 class="m-0">Notes & Policy</h6>
                        <div>
                          <button class="btn">
                            <em
                              (click)="instructionNotesInfo = !instructionNotesInfo"
                              class="fa fa-sort-desc"
                              [ngClass]="instructionNotesInfo ? '' : 'antirotate'"
                            ></em>
                          </button>
                        </div>
                      </div>
                      <div
                        [ngClass]="
                          instructionNotesInfo ? 'collapsecard' : 'expandcard'
                        "
                      >
                        <div class="card border-0 card-scrollbar bg-transparent">
                          <div
                            class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                          >
                            <div class="row">
                              <div class="col-2 text-right">
                                Client Instructions:
                              </div>
                              <div class="col-4">
                                {{ programLocationData?.client_instructions }}
                              </div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">
                                Invoice Instructions:
                              </div>
                              <div class="col-4">
                                {{ programLocationData?.invoice_instructions }}
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-2 text-right">General Notes:</div>
                              <div class="col-4">
                                {{ programLocationData?.general_notes }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="search-spear-background">
                  <app-quick-link [links]="quickLinks"></app-quick-link>
                </div>

                <div class="search-spear-background mt-2">
                  <app-credit-balance [balances]="creditBalances"></app-credit-balance>
                </div>
              </div>
            </div>

          </ng-container>

          <ng-container *ngIf="activeTab == 'Locations'">
            <div class="search-spear-background p-2">
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="accordian-tab card-header title-space spear-table-header-background"
                  >
                    <h6 class="m-0">Locations</h6>
                    <div>
                      <button class="btn">
                        <em
                          (click)="generalInfo = !generalInfo"
                          class="fa fa-sort-desc"
                          [ngClass]="generalInfo ? '' : 'antirotate'"
                        ></em>
                      </button>
                    </div>
                  </div>
                  <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                    <div class="card border-0 card-scrollbar">
                      <div
                        class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                      >
                        <table class="table">
                          <thead>
                            <tr>
                              <th class="border-0" scope="col">Number</th>
                              <th class="border-0" scope="col">Contacts</th>
                              <th class="border-0" scope="col">Last Case</th>
                            </tr>
                          </thead>

                          <ng-container
                            *ngIf="
                              clientData?.locations?.length;
                              else showNoLocation
                            "
                          >
                            <tbody>
                              <tr
                                class="bg-white"
                                *ngFor="let location of clientData?.locations"
                              >
                                <td lass="text-center">
                                  {{ location.location_name }}
                                </td>
                                <td lass="text-center">
                                  {{ location.primary_phone }}
                                </td>
                                <td lass="text-center"></td>
                              </tr>
                            </tbody>
                          </ng-container>

                          <ng-template ##showNoLocation>
                            <tbody>
                              <tr class="bg-white">
                                <td colspan="3" class="text-center">
                                  Data not available
                                </td>
                              </tr>
                            </tbody>
                          </ng-template>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="activeTab == 'Contacts'">
            <div class="search-spear-background p-2">
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="accordian-tab card-header title-space spear-table-header-background"
                  >
                    <h6 class="m-0">Contacts</h6>
                    <div>
                      <button class="btn">
                        <em
                          (click)="generalInfo = !generalInfo"
                          class="fa fa-sort-desc"
                          [ngClass]="generalInfo ? '' : 'antirotate'"
                        ></em>
                      </button>
                    </div>
                  </div>
                  <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                    <div class="card border-0 card-scrollbar">
                      <div
                        class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                      >
                        <table class="table">
                          <thead>
                            <tr>
                              <th class="border-0" scope="col">Name</th>
                              <th class="border-0" scope="col">Title</th>
                              <th class="border-0" scope="col">Location</th>
                              <th class="border-0" scope="col">Email</th>
                              <th class="border-0" scope="col">Last Case</th>
                            </tr>
                          </thead>
                          <ng-container
                            *ngIf="
                              clientData?.contacts?.length;
                              else noContactFound
                            "
                          >
                            <tbody>
                              <tr
                                class="bg-white"
                                *ngFor="let contact of clientData?.contacts"
                              >
                                <td>
                                  {{
                                    contact?.first_name +
                                      " " +
                                      contact?.middle_name +
                                      " " +
                                      contact?.last_name
                                  }}
                                </td>
                                <td>{{ contact?.title }}</td>
                                <td>{{ contact?.location?.location_name }}</td>
                                <td>{{ contact?.email }}</td>
                                <td></td>
                              </tr>
                            </tbody>
                          </ng-container>
                          <ng-template #noContactFound>
                            <tbody>
                              <tr class="bg-white">
                                <td colspan="5" class="text-center">
                                  Data not available
                                </td>
                              </tr>
                            </tbody>
                          </ng-template>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="activeTab == 'Program Contact'">
            <div class="search-spear-background p-2">
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="accordian-tab card-header title-space spear-table-header-background"
                  >
                    <h6 class="m-0">Program Contact List</h6>
                    <div>
                      <button
                        class="btn viewBtn limos-button-background text-white btn-sm mr-2"
                        (click)="openPopup(addProgramLocationContact)"
                      >
                        Add Program Contact
                      </button>
                      <button class="btn">
                        <em
                          (click)="generalInfo = !generalInfo"
                          class="fa fa-sort-desc"
                          [ngClass]="generalInfo ? '' : 'antirotate'"
                        ></em>
                      </button>
                    </div>
                  </div>
                  <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                    <div class="card border-0 card-scrollbar">
                      <div
                        class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                      >
                        <table class="table">
                          <thead>
                            <tr>
                              <th class="border-0" scope="col">Name</th>
                              <th class="border-0" scope="col">
                                Title
                              </th>
                              <th class="border-0" scope="col">
                                Email
                              </th>
                              <th class="border-0" scope="col">
                                Phone
                              </th>
                              <th class="border-0" scope="col">
                                Active ?
                              </th>

                            </tr>
                          </thead>
                          <tbody *ngIf="programContacts?.length">
                            <ng-container *ngFor="let contact of programContacts">
                              <tr class="bg-white">
                                <td><a
                                  [routerLink]="['/client-contact', contact.id]"
                                  target="_blank"
                                  class="cursor-pointer primary-text font-weight-semibold"
                                  >{{ contact?.full_name }}</a></td>
                                <td>{{ contact?.role }}</td>
                                <td>{{ contact?.email }}</td>
                                <td>{{ contact?.mobile_phone }}</td>
                                <td>{{ contact?.is_active  ? 'Yes' : 'No' }}</td>
                              </tr>
                            </ng-container>
                          </tbody>
                          <tbody *ngIf="!programContacts?.length">
                            <tr class="bg-white">
                              <td colspan="5" class="text-center">Data not available</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          class="px-0 py-0 paginationWrapper d-flex"
                          *ngIf="!(!programContacts || programContacts.length === 0)"
                        >
                          <ngb-pagination
                            [(collectionSize)]="programContactTotal"
                            [(page)]="programContactPage"
                            [pageSize]="programContactLimit"
                            [maxSize]="10"
                            [boundaryLinks]="true"
                            (pageChange)="onPageChangeProgramContacts($event)"
                          >
                          </ngb-pagination>
                          <div class="selected d-flex align-items-center">
                            <select
                              (change)="onSizeChangeProgramContacts(programContactLimit)"
                              class="custom-select table-select h-100"
                              [(ngModel)]="programContactLimit"
                            >
                              <option [ngValue]="20">20</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="75">75</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            <p class="mb-0 ml-2 text-nowrap">
                              Showing {{ programContactPage * programContactLimit - programContactLimit + 1 }}
                              -
                              {{
                                programContactPage * programContactLimit > programContactTotal
                                  ? programContactTotal
                                  : programContactPage * programContactLimit
                              }}
                              of {{ programContactTotal }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="activeTab == 'Price List'">
            <div class="search-spear-background p-2">
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="accordian-tab card-header title-space spear-table-header-background"
                  >
                    <h6 class="m-0">Inventory</h6>
                    <div>
                      <button
                        class="btn viewBtn btn-info text-white btn-sm mr-2"
                      >
                        New
                      </button>
                      <button
                        class="btn viewBtn limos-button-background text-white btn-sm mr-2"
                      >
                        Edit
                      </button>
                      <button class="btn">
                        <em
                          (click)="generalInfo = !generalInfo"
                          class="fa fa-sort-desc"
                          [ngClass]="generalInfo ? '' : 'antirotate'"
                        ></em>
                      </button>
                    </div>
                  </div>
                  <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                    <div class="card border-0 card-scrollbar">
                      <div
                        class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                      >
                        <table class="table">
                          <thead>
                            <tr>
                              <th class="border-0" scope="col">Invoice Item</th>
                              <th class="border-0" scope="col">
                                Default Item Code
                              </th>
                              <th class="border-0" scope="col">
                                Default Price
                              </th>
                              <th class="border-0" scope="col">
                                Default Tax Rate
                              </th>
                              <th class="border-0" scope="col">
                                Custom Item Code
                              </th>
                              <th class="border-0" scope="col">Custom Price</th>
                              <th class="border-0" scope="col">
                                Custom Tax Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody *ngIf="priceList?.length">
                            <ng-container *ngFor="let price of priceList">
                              <tr class="bg-white">
                                <td>{{  price?.item_price?.invoice_item }}</td>
                                <td>{{  price?.item_price?.item_code }}</td>
                                <td>{{  price?.item_price?.default_price }}</td>
                                <td>{{  price?.item_price?.default_tax_rate }}</td>
                                <td></td>
                                <td>{{  price?.custom_price }}</td>
                                <td>{{  price?.custom_tax_rate }}</td>
                              </tr>
                            </ng-container>
                          </tbody>
                          <tbody *ngIf="!priceList?.length">
                            <tr class="bg-white">
                              <td colspan="7" class="text-center">Data not available</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          class="px-0 py-0 paginationWrapper d-flex"
                          *ngIf="!(!priceList || priceList.length === 0)"
                        >
                          <ngb-pagination
                            [(collectionSize)]="priceListTotal"
                            [(page)]="priceListPage"
                            [pageSize]="priceListLimit"
                            [maxSize]="10"
                            [boundaryLinks]="true"
                            (pageChange)="onPageChangePriceList($event)"
                          >
                          </ngb-pagination>
                          <div class="selected d-flex align-items-center">
                            <select
                              (change)="onSizeChangePriceList(priceListLimit)"
                              class="custom-select table-select h-100"
                              [(ngModel)]="priceListLimit"
                            >
                              <option [ngValue]="20">20</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="75">75</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            <p class="mb-0 ml-2 text-nowrap">
                              Showing {{ priceListPage * priceListLimit - priceListLimit + 1 }}
                              -
                              {{
                                priceListPage * priceListLimit > priceListTotal
                                  ? priceListTotal
                                  : priceListPage * priceListLimit
                              }}
                              of {{ priceListTotal }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addProgramLocationContact let-modal>
  <div class="modal-header">
    <h6>Add Program Contact</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-form text-sm">
    <form [formGroup]="programContactForm">
      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="client"
              >Client</span
            >
            <input name="client" id="client" class="form-control"
            [ngbTypeahead]="searchClient"
            [resultTemplate]="clientSearchTemplate"
            [inputFormatter]="clientSearchFormatter"
            />
            <div
            *ngIf="clientSearchLoader"
            class="clientSearchLoader"
          ></div>
            <ng-template
              #clientSearchTemplate
              let-r="result"
              let-t="term"
            >
              <div [term]="t">
                {{ r.full_name }}
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="program_location"
              >Location</span
            >
            <input name="program_location" id="program_location" class="form-control"
            [ngbTypeahead]="searchProgramLocation"
            [resultTemplate]="programLocationSearchTemplate"
            [inputFormatter]="programLocaionSearchFormatter"
            />
            <div
            *ngIf="programLocationSearchLoader"
            class="programLocationSearchLoader"
          ></div>
            <ng-template
              #programLocationSearchTemplate
              let-r="result"
              let-t="term"
            >
              <div [term]="t">
                {{ r.program_location_name }}
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="role"
              >Role</span
            >
            <select name="role" id="role" class="form-control" formControlName="role">
              <option value="">Select</option>
              <option value="Adjuster">Adjuster</option>
            </select>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="modalService.dismissAll();programContactForm.reset()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm text-white mr-1"
            [disabled]="programContactForm.invalid"
            (click)="submitProgramContact()"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
